<template>
    <v-form v-model="is_valid"
            :disabled="loading"
            v-on:submit="noSubmit">
        <v-container class="base container-fluid">
            <h1>Habilitar autenticação 2FA</h1>
            <v-row v-if="loading">
                <v-col class="justify-center align-center pa-8">
                    <v-progress-circular :size="35"
                                        color="primary"
                                        indeterminate />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    Baixe um app de autenticação em seu celular para poder cadastrar a confirmação 2FA.
                </v-col>
                <v-col>
                    <ul>
                        <li>
                            Microsoft Authenticator para
                            <a href="https://go.microsoft.com/fwlink/?Linkid=825072">Android</a> ou para
                            <a href="https://go.microsoft.com/fwlink/?Linkid=825073">iOS</a>.
                        </li>
                        <li>
                            Google Authenticator para
                            <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&amp;hl=pt_BR">Android</a> ou para
                            <a href="https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8&l=pt-BR">iOS</a>.
                        </li>
                    </ul>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    Leia o QR code
                    <span class="col-flow">ao lado</span>
                    <span class="row-flow">abaixo</span>
                    ou registre o código
                    <div class="key-box" @click="code2Clip" title="Clique para copiar">{{ sharedKey }}</div>
                    no seu aplicativo de autenticação. Espaços e diferenças entre
                    maiúsculas e minúsculas não afetam o cadastro. Clique no código acima para copiá-lo para
                    a área de transferência.
                </v-col>
                <v-col class="qr-code">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="qrcode"/>
                    </svg>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    Após cadastrar o QR code ou código do sistema em seu autenticador ele
                    irá gerar um código unico de confirmação. Preencha esse código na caixa de texto
                    <span class="col-flow">ao lado</span>
                    <span class="row-flow">abaixo</span>
                    e clique em <strong>confirmar</strong> para finalizar o processo.
                </v-col>
                <v-col>
                    <v-row>
                        <v-col>
                            <v-text-field v-model.trim="confirmCode"
                                        placeholder="Código de confirmação de seu autenticador"
                                        label="Código de confirmação de seu autenticador"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="message">
                        <v-col>
                            {{ message }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-btn class="btn-ok"
                                   @click="register">Confirmar</v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <ViewRecoveryCodes :data="codes"
                               v-if="viewCodes"
                               @close="closeCodes"></ViewRecoveryCodes>
        </v-container>
    </v-form>
</template>

<style>
</style>

<style lang="css" scoped>
.base > .row {
    border-bottom: 1px solid black;
}
.key-box {
    font-weight: bold;
    font-size: 1.2rem;
    background-color: navy;
    color: white;
    border-radius: 10px;
    margin: 0;
    padding: 0.25rem;
    text-align: center;
    cursor: pointer;
}
.qr-code {
    align-items: center;
    align-content: center;
    text-align: center;
}
.qr-code > svg {
    width: 256px;
    height: 256px;
}
.row-flow {
    display: none;
}
.btn-ok {
    border-radius: 20px;
    padding: 0.5rem;
    font-weight: bold;
    background-color: rgba(0,128,0,0.5) !important;
    color: white;
}

@media screen and (max-width: 800px) {
    .key-box {
        font-size: 1.4rem;
    }
    .row {
        flex-direction: column;
    }
    .row-flow {
        display: inline;
    }
    .col-flow {
        display: none;
    }
}
</style>

<script lang="js">
import { QRCode } from '@/services/qrcode';
import ApiService from '@/services/ApiService';
import ViewRecoveryCodes from './components/ViewRecoveryCodes.vue';

export default          {
    data                () {
        return          {
            api         : undefined,
            qrcode      : undefined,

            is_valid    : false,
            loading     : false,
            viewCodes   : false,

            qrCodeUrl   : '',
            sharedKey   : '',
            confirmCode : '',

            message     : '',
            code_count  : 0,
            codes       : []
        }
    },
    components          : { ViewRecoveryCodes },
    methods             : {
        async loadInfo  () {
            let shKey = '...';
            try {
                this.loading = true;
                this.sharedKey = 'Aguarde...';
                let resp = await this.api.mfaGetQRCodeData();
                if (!resp.success) {
                    this.$toast.error(resp.message || 'Falha não identificada ao carregar dados.');
                    return;
                }
                const { sharedKey, uri } = resp.content;
                this.qrCodeUrl = uri;
                shKey = sharedKey;
                this.makeCode();
            } finally {
                this.sharedKey = shKey;
                this.loading = false;
            }
        },
        async register  () {
            const code = this.confirmCode || '';
            if (!code) { return; }
            try {
                this.loading = true;
                let resp = await this.api.mfaRegisterApp(code);
                const { message, code_count, codes } = resp.content;
                if (!resp.success) {
                    this.$toast.error(message || resp.message || 'Falha não identificada ao carregar dados.');
                    return;
                }
                this.message    = message;
                this.code_count = code_count;
                this.codes      = codes;
                this.viewCodes  = (code_count > 0) && codes && (!!codes.length);
                if (!this.viewCodes) {
                    this.closeCodes();
                }
            } finally {
                this.loading = false;
            }
        },
        async code2Clip () {
            try {
                await navigator.clipboard.writeText(this.sharedKey);
                this.$toast.info(`Código '${this.sharedKey}' copiado para a área de transferência.`);
            } catch (e) {
                this.$toast.error(
                    e.message ||
                    (e.getMessage && e.getMessage()) ||
                    'Falha ao copiar para a área de transferência');
            }
        },
        makeCode        () {
            if (!this.qrCodeUrl) {
                alert("Input a text");
                return;
            }
            this.qrcode.makeCode(this.qrCodeUrl);
        },
        closeCodes      () {
            this.viewCodes = false;
            this.$router.push({ name: "TwoFactorAuthentication" });
        },
        noSubmit        (e) {
            e.preventDefault();
            e.resultValue = 0;
            return Promise.resolve();
        }
    },
    mounted             () {
        this.api        = new ApiService();
        this.qrcode     = new QRCode(
            document.getElementById('qrcode'),
            { width: 256, height: 256, useSVG: true });
        return this.loadInfo();
    }
}
</script>